// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"535":"login","940":"request"}[chunkId] + "." + {"535":"274f5298","940":"80cdfbfc"}[chunkId] + ".js";
};